import { apiCaller } from '../ApiCaller/ApiCaller';

export async function updateOpportunityDataOfContact(opportunityData) {

    const updateOpportunityData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/updateOpportunityDetail", opportunityData);
      return updateOpportunityData;
}